// extracted by mini-css-extract-plugin
module.exports = {"sort":"ID","selected":"JD","disabled":"KD"};